module.exports = __webpack_public_path__ + "static/img/13.26820c02.jpg";